import { useEffect, useRef, useState, useMemo } from "react";
import { Link, useLocation, useHistory } from "react-router-dom"
//-------------------------------------------------
import Resize from "src/components/common/resize";
import UserInfo from "src/components/common/userInfo";
import magnifierImg from "src/img/magnifier.png";
import { laborCategorys, laborShopsCategorys } from "src/components/projects/workInstruction/workInstructionForm";
import { useMyStore } from "src/components/main/mainStore";
import {
    payRollRuleChangeDate, boolAndReducer, getTimeStamp, 
    onlyUnique, numberReducer, round, emailsListFor1245Exception5x8,
    weeknum, getDatefromWeekNum, getDatefromWeekNum0, objAscSort, restDayProjectHashKey,
    myAxios, MyFormData, defaultEmptyDateTime, MyDate, simpleStatusColorCode, arrayReducer, objectReducer, weekIndexes,
    appTitle
} from "src/components/common/functions";
import Export from "./export";
//-------------------------------------------------
const CSVExport = ({ week, department }) => {
    const handleCSVExport = async () => {
        try {
            const formData = new MyFormData();
            formData.append("week", week);
            formData.append("department", department);
            
            const response = await myAxios("payroll/exportCSV.php", formData);
            
            if (response && response.data) {
                // Handle CSV download
                const blob = new Blob([response.data], { type: 'text/csv' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `payroll_week_${week}.csv`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            }
        } catch (error) {
            console.error("CSV export failed:", error);
        }
    };

    return (
        <button 
            className="btn btn-success ml-2" 
            onClick={handleCSVExport}
        >
            CSV Export
        </button>
    );
};
//-------------------------------------------------
export const gatherHours = (workLog, unionName = workLog.unionName) => {
    if(workLog.workLogStatus === "Created"){
        return [0, 0, 0]
    }
    const travelStart =  Date.parse(workLog.travelStartTime.replace(/-/g, "/"));
    const workStart = Date.parse(workLog.workStartTime.replace(/-/g, "/"));
    const workEnd = Date.parse(workLog.workEndTime.replace(/-/g, "/"));
    const travelEnd = Date.parse(workLog.travelEndTime.replace(/-/g, "/"));

    const isPreDriver = workLog.preDriver === "Yes"?true:false;
    const isPostDriver = workLog.postDriver === "Yes"?true:false;
    const driverDependentUnions = [
        "SC Local 300", 
        "SC Local 652", 
        "SC Local 1184", 
        "185",
        "304", 
        "270",
        "Local 294", 
        "Local 783", 
    ];
    const travel1 = !isPreDriver && driverDependentUnions.includes(unionName)?0:(workStart - travelStart) / 3600000;
    const travel2 = !isPostDriver && driverDependentUnions.includes(unionName)?0:(travelEnd - workEnd) / 3600000;
    const workHours = workLog.hadLunch === "Yes" ? (workEnd - workStart) / 3600000 - 0.5:(workEnd - workStart) / 3600000;
    return [workHours, travel1, travel2];
}
export const calculateHours = (
    workHours, 
    travel1, 
    travel2, 
    travelStart, 
    travelEnd, 
    unionName, 
    email, 
    isTravelTag,
    department
) => {
    if(workHours === 0 && travel1 === 0 && travel2 === 0){
        return [0, 0, 0, 0, 0]
    }
    const travel = travel1 + travel2;
    let regular = 0, ot1 = 0, ot2 = 0, travelHours = 0, abnormalHours = 0; // plus $3/h for regular
    switch(unionName){
        //-------------------------------------------------------------
        case "1245":
            //rate is same for everyBody
            if(travel1 > 1){
                workHours += travel1 - 1
            }
            if(travel2 > 1){
                workHours += travel2 - 1
            }
            //------------------------------------------------------
            if(!emailsListFor1245Exception5x8.includes(email)){
                if(workHours <= 4){
                    regular = 4;
                }else if(workHours <= 6){
                    regular = 6;
                }else if(workHours <= 8){
                    regular = 8;
                }else if(workHours <= 10){
                    regular = 10;
                }else{
                    regular = 10;
                    ot2 = workHours - 10;
                }
                //Friday: makeup day or OT
                if(
                    (new Date(travelStart)).getDay() === 5 ||
                    (new Date(travelStart)).getDay() === 6 ||
                    (new Date(travelStart)).getDay() === 0
               ){
                    regular = 0;
                    ot2 = workHours;
                }
            }else{
                if(workHours <= 4){
                    regular = 4;
                }else if(workHours <= 6){
                    regular = 6;
                }else if(workHours <= 8){
                    regular = 8;
                }else{
                    regular = 8;
                    ot2 = workHours - 8;
                }
                if(
                    (new Date(travelStart)).getDay() === 6 ||
                    (new Date(travelStart)).getDay() === 0
               ){
                    regular = 0;
                    ot2 = workHours;
                }
            }
            break;
        //-------------------------------------------------------------
        case "SC Local 300":
        case "SC Local 652":
        case "SC Local 1184":
        case "Local 783":
            if(workHours === 0 && isTravelTag){
                regular = 0;
            }else if(workHours <= 4){
                regular = 4;
            }else if(workHours <= 6){
                regular = 6;
            }else if(workHours <= 8){
                regular = 8;
            }else if(workHours <= 12){
                regular = 8;
                ot1 = workHours - 8;
            }else{
                regular = 8;
                ot1 = 4;
                ot2 = workHours - 12;
            }
            //Saturday ot1, Sunday ot2
            if((new Date(travelStart)).getDay() === 6){
                regular = 0;
                ot1 = workHours;
                ot2 = 0;
            }else if((new Date(travelStart)).getDay() === 0){
                regular = 0;
                ot1 = 0;
                ot2 = workHours;
            }
            // change here
            travelHours = travel;
            break;
        //-------------------------------------------------------------
        case "185":
        case "270":
        case "Local 294":
        case "304":
            if(department === "Locating" || department === "Outside Service" || department === "Scanning&Coring"){
                travelHours = (travel1 > 1? travel1 - 1: 0) + (travel2 > 1? travel2 - 1: 0);
            }else{
                travelHours = travel;
            }
            if(payRollRuleChangeDate(new Date(travelStart))){
                //summer: (4, 8)
                if(workHours <= 4){
                    regular = 4;
                }else if(workHours <= 8){
                    regular = 8;
                }else if(workHours <= 12){
                    regular = 8;
                    ot1 = workHours - 8;
                }else{
                    regular = 8;
                    ot1 = 4;
                    ot2 = workHours - 12;
                }
            }else{
                //winter: (4, 6, 8)
                if(workHours <= 4){
                    regular = 4;
                }else if(workHours <= 6){
                    regular = 6;
                }else if(workHours <= 8){
                    regular = 8;
                }else if(workHours <= 12){
                    regular = 8;
                    ot1 = workHours - 8;
                }else{
                    regular = 8;
                    ot1 = 4;
                    ot2 = workHours - 12;
                }
            }
            //Saturday ot1, Sunday ot2
            if((new Date(travelStart)).getDay() === 6){
                regular = 0;
                ot1 = workHours;
                ot2 = 0;
            }else if((new Date(travelStart)).getDay() === 0){
                regular = 0;
                ot1 = 0;
                ot2 = workHours;
            }
            //-------------------------------------------------------------
            //abnoral hours
            // const workStartT = timeStringToFloat(formData.get("workStartTime"));
            // const workEndT = timeStringToFloat(formData.get("workEndTime"));
            // if(workEndT > 16){
            //     if(workStartT < 16){
            //         abnormalHours = workEndT - 16;
            //     }else{
            //         abnormalHours = workEndT - workStartT;
            //     }
            // }
            break;
        //-------------------------------------------------------------
        case "Local 3":
            workHours += travel;
            const md = new MyDate(travelStart).s().slice(5, 10).replace(/-/g,"/");
            const in48Range = md >= "05/01" && md <= "10/31";
            if((new Date(travelStart)).getDay() === 6){
                //Saturday
                if(workHours === 0 && isTravelTag){
                    ot1 = 0;
                }else if(workHours <= 2 && !in48Range){
                    ot1 = 2;
                }else if(workHours <= 4){
                    ot1 = 4;
                }else if(workHours <= 6 && !in48Range){
                    ot1 = 6;
                }else if(workHours <= 8){
                    ot1 = 8;
                }else if(workHours <= 12){
                    ot1 = workHours;
                }else{
                    ot1 = 12;
                    ot2 = workHours - 12;
                }
            }else if((new Date(travelStart)).getDay() === 0){
                //Sunday
                if(workHours === 0 && isTravelTag){
                    ot2 = 0;
                }else if(workHours <= 2 && !in48Range){
                    ot2 = 2;
                }else if(workHours <= 4){
                    ot2 = 4;
                }else if(workHours <= 6 && !in48Range){
                    ot2 = 6;
                }else if(workHours <= 8){
                    ot2 = 8;
                }else{
                    ot2 = workHours;
                }
            }else if(
                (new Date(travelStart)).toLocaleDateString() !== 
                (new Date(travelEnd)).toLocaleDateString()
            ){
                // Overnight
                if(workHours === 0 && isTravelTag){
                    ot1 = 0;
                }else if(workHours <= 2 && !in48Range){
                    ot1 = 2;
                }else if(workHours <= 4){
                    ot1 = 4;
                }else if(workHours <= 6 && !in48Range){
                    ot1 = 6;
                }else if(workHours <= 8){
                    ot1 = 8;
                }else if(workHours <= 12){
                    ot1 = workHours;
                }else{
                    ot1 = 12;
                    ot2 = workHours - 12;
                }
            }else{
                if(workHours <= 2 && !in48Range){
                    regular = 2;
                }else if(workHours <= 4){
                    regular = 4;
                }else if(workHours <= 6 && !in48Range){
                    regular = 6;
                }else if(workHours <= 8){
                    regular = 8;
                }else if(workHours <= 12){
                    regular = 8;
                    ot1 = workHours - 8;
                }else{
                    regular = 8;
                    ot1 = 4;
                    ot2 = workHours - 12;
                }
            }
            //-------------------------------------------------------------
            //abnoral hours
            //const travelStartT = timeStringToFloat(formData.get("travelStartTime"));
            //const travelEndT = timeStringToFloat(formData.get("travelEndTime"));

            // if(travelStartT < 4 || travelStartT < 10){
            //     regular = 0;
            //     ot1 = workHours;
            //     ot2 = 0;
            // }

            //-------------------------------------------------------------
            // normal time between 10am to 4pm
            // if(travelStartT < 10){
            //     if(travelEndT > 10){
            //         abnormalHours += 10 - travelStartT;
            //     }else{
            //         abnormalHours = travelEndT - travelStartT;
            //     }
            // }
            // if(travelEndT > 16){
            //     if(travelStartT < 16){
            //         abnormalHours += travelEndT - 16;
            //     }else{
            //         abnormalHours = travelEndT - travelStartT;
            //     }
            // }
            //-------------------------------------------------------------
            break;
        //-------------------------------------------------------------
        case "Local 12":
            workHours += travel;
            if((new Date(travelStart)).getDay() === 6){
                //Saturday
                if(workHours === 0 && isTravelTag){
                    ot1 = 0;
                }else if(workHours <= 2){
                    ot1 = 2;
                }else if(workHours <= 4){
                    ot1 = 4;
                }else if(workHours <= 12){
                    ot1 = workHours;
                }else{
                    ot1 = 12;
                    ot2 = workHours - 12;
                }
            }else if((new Date(travelStart)).getDay() === 0){
                //Sunday
                if(workHours === 0 && isTravelTag){
                    ot2 = 0;
                }else if(workHours <= 2){
                    ot2 = 2;
                }else if(workHours <= 4){
                    ot2 = 4;
                }else{
                    ot2 = workHours;
                }
            }else if(
                (new Date(travelStart)).toLocaleDateString() !== 
                (new Date(travelEnd)).toLocaleDateString()
            ){
                //Overnight
                if(workHours === 0 && isTravelTag){
                    ot1 = 0;
                }else if(workHours <= 2){
                    ot1 = 2;
                }else if(workHours <= 4){
                    ot1 = 4;
                }else{
                    ot1 = 4;
                    ot2 = workHours - 4;
                }
            }else{
                if(workHours <= 2){
                    regular = 2;
                }else if(workHours <= 4){
                    regular = 4;
                }else if(workHours <= 8){
                    regular = workHours;
                }else if(workHours <= 12){
                    regular = 8;
                    ot1 = workHours - 8;
                }else{
                    regular = 8;
                    ot1 = 4;
                    ot2 = workHours - 12;
                }
            }
            //-------------------------------------------------------------
            //abnoral hours
            //const travelStartT = timeStringToFloat(formData.get("travelStartTime"));
            //const travelEndT = timeStringToFloat(formData.get("travelEndTime"));

            // if(travelStartT < 4 || travelStartT < 10){
            //     regular = 0;
            //     ot1 = workHours;
            //     ot2 = 0;
            // }

            //-------------------------------------------------------------
            // normal time between 10am to 4pm
            // if(travelStartT < 10){
            //     if(travelEndT > 10){
            //         abnormalHours += 10 - travelStartT;
            //     }else{
            //         abnormalHours = travelEndT - travelStartT;
            //     }
            // }
            // if(travelEndT > 16){
            //     if(travelStartT < 16){
            //         abnormalHours += travelEndT - 16;
            //     }else{
            //         abnormalHours = travelEndT - travelStartT;
            //     }
            // }
            //-------------------------------------------------------------
            break;
        //-------------------------------------------------------------
        default /*Non-Union*/:
            workHours += travel;
            if(workHours <= 8){
                regular = workHours;
            }else if(workHours <= 12){
                regular = 8;
                ot1 = workHours - 8;
            }else{
                regular = 8;
                ot1 = 4;
                ot2 = workHours - 12;
            }
            if((new Date(travelStart)).getDay() === 6){
                //Saturday
                regular = 0;
                ot1 = workHours;
                ot2 = 0;
            }else if((new Date(travelStart)).getDay() === 0){
                //Sunday
                regular = 0;
                ot1 = 0;
                ot2 = workHours;
            }
            break;
    }
    if(isTravelTag){
        regular = 0;
        ot1 = 0; 
        ot2 = 0;
        travelHours = travel;
        abnormalHours = 0;
    }
    return([regular, ot1, ot2, travelHours, abnormalHours]);
}
//-------------------------------------------------
export default function Payroll({ tabTitle }){
    const curUser = useMyStore(state => state.user);
    const [updateDateTime, setUpdateDateTime] = useState(getTimeStamp());
    //-------------------------------------------------
    const getTotalHours = p => {
        const outputArray = [];
        p.forEach((f, i) => {
            //generalize
            const dataArray = [];
            f.sort((a, b) => objAscSort(a, b, "travelStartTime")).forEach((ff) => {
                dataArray.push(gatherHours(ff));
            })
            const dataArrayValid = dataArray.filter(d => d.length > 0);
            if(dataArrayValid.length){
                const totalHours = dataArrayValid.map(d => d.reduce(numberReducer, 0)).reduce(numberReducer, 0);
                const final = calculateHours(
                    totalHours - dataArrayValid.map(d => d[1]).reduce(numberReducer, 0) - dataArray.map(d => d[2]).reduce(numberReducer, 0), 
                    dataArrayValid.map(d => d[1]).reduce(numberReducer, 0), 
                    dataArrayValid.map(d => d[2]).reduce(numberReducer, 0), 
                    Date.parse(f[0].travelStartTime.replace(/-/g, "/")), 
                    Date.parse(f[0].travelEndTime.replace(/-/g, "/")), 
                    f[0].unionName, 
                    f[0].labor, 
                    f[0].laborCategory === "Travel",
                    f[0].department
                );
                outputArray.push({
                    jobs: f.sort((a, b) => objAscSort(a, b, "travelStartTime")),
                    regular: round(final[0], 2), 
                    ot1: round(final[1], 2), 
                    ot2: round(final[2], 2), 
                    travel: round(final[3], 2)
                })
            }else{
                outputArray.push({
                    jobs: f.sort((a, b) => objAscSort(a, b, "travelStartTime")),
                    regular:0, 
                    ot1: 0, 
                    ot2: 0, 
                    travel: 0
                })
            }
        })
        return(outputArray);
    }
    //-------------------------------------------------
    const allCreated = arr => {
        return !arr.map(a => a.workLogStatus === "Created"?0:1).reduce(numberReducer, 0);
    }
    //-------------------------------------------------
    const handleEditHours = (userData, dayNum, hoursData) => {
        const override = getOverrideForEmployeeDay(userData.labor, dayNum);
        setEditHoursData({
            userName: userData.userName,
            email: userData.labor,
            day: dayNum,
            regular: override ? parseFloat(override.regular) : hoursData.regular,
            ot1: override ? parseFloat(override.ot1) : hoursData.ot1,
            ot2: override ? parseFloat(override.ot2) : hoursData.ot2,
            travel: override ? parseFloat(override.travel) : hoursData.travel
        });
        setShowEditModal(true);
    };
    //-------------------------------------------------
    const handleSaveEditedHours = async () => {
        const formData = new MyFormData();
        formData.append("week", week);
        formData.append("hoursOverrideEmail", editHoursData.email);
        formData.append("day", editHoursData.day);
        formData.append("regular", editHoursData.regular);
        formData.append("ot1", editHoursData.ot1);
        formData.append("ot2", editHoursData.ot2);
        formData.append("travel", editHoursData.travel);
        
        const res = await myAxios("payroll/overrideHours.php", formData);
        if(res && res.data && res.data.data){
            // Update only the override hours with the returned data
            setOverrideHours(res.data.data);
            setShowEditModal(false);
        }
    };
    //-------------------------------------------------
    const history = useHistory();
    const location = useLocation();
    //-------------------------------------------------
    const [rawData, setRawData] = useState([]);
    const [showLoading, setShowLoading] = useState(true);
    const [weeks, setWeeks] = useState([]);
    const [department, setDepartment] = useState("All");
    const [laborCategory, setLaborCategory] = useState("All");
    const [showAll, setShowAll] = useState(false);
    const [showHours, setShowHours] = useState(false);
    const [showTimes, setShowTimes] = useState(false);
    const [showOvertimes, setShowOvertimes] = useState(false);
    const [usersList, setUsersList] = useState([]);
    const [status, setStatus] = useState("All");
    const [filterWords, setFilterWords] = useState("");
    const [showEditModal, setShowEditModal] = useState(false);
    const [overrideHours, setOverrideHours] = useState([]);
    const [editHoursData, setEditHoursData] = useState({
        userName: "",
        email: "",
        day: 0,
        regular: 0,
        ot1: 0,
        ot2: 0,
        travel: 0
    });
    //-------------------------------------------------
    const getOverrideForEmployeeDay = (email, day) => {
        return overrideHours.find(override => override.employee === email && override.day === day);
    };
    //-------------------------------------------------
    const conditionalBorder = status === "All"?"none":"1px solid black";
    const week = location.pathname.split("/")[2] || weeknum(new MyDate());
    const departments = ["All", 
        "Potholing" ,
        "Locating", 
        "Scanning&Coring", 
        "CCTV", 
        "Mapping&Surveying", 
        "QA/QC", 
        "Traffic Control", 
        "Hydro Vac Excavation", 
        "Straight Vacuum Services", 
        "LA", 
        "Arizona"
    ];
    //-------------------------------------------------
    const filteredData = useMemo(() => rawData
    .map(raw => ({...raw, 
        projectName: raw.projectNumber + " - " + raw.organizationName + " - " + raw.clientProjectNumber,
        userName: raw.userName?.replace(/ {2}/g, " ")
    }))
    .filter(raw => 
    (
        (status !== "All"?
            (
                status === "Billed"?
                    raw.billed === "Yes"
                    :
                    raw.workLogStatus === status
            )
            :
            true
        ) && 
        (department !== "All"?raw.department === department:true) && 
        (laborCategory !== "All"?raw.laborCategory === laborCategory:true) && 
        (filterWords.toLowerCase().split(" ").map(f => JSON.stringify(
            [raw.userName, raw.projectName]
        ).toLowerCase().indexOf(f) > -1).reduce(boolAndReducer, true))
    )),
    [filterWords, rawData, status, department, laborCategory]);
    //-------------------------------------------------
    const userEveryDayCalculatedData = useMemo(() => (
        (showAll?
        usersList.filter(u => (department !== "All"?u.department === department:true)).map(u => u.email):
        filteredData.map(raw => raw.labor).filter(onlyUnique))
    ).map(f => filteredData.filter(ff => ff.labor === f)).map(user => 
        weekIndexes.map((_, i) => 
        user.filter(job => (
            new Date(job.startTime.substring(0, 10).replace(/-/g, "/"))
        ).getDay() === i
        ))
    ).map(jobsByDay => ({
        hours: getTotalHours(jobsByDay),
        labor: jobsByDay.reduce(arrayReducer, []).reduce(objectReducer, {}).labor, 
        userName: jobsByDay.reduce(arrayReducer, []).reduce(objectReducer, {}).userName, 
        department: jobsByDay.reduce(arrayReducer, []).reduce(objectReducer, {}).department, 
        region: jobsByDay.reduce(arrayReducer, []).reduce(objectReducer, {}).region, 
        unionName: jobsByDay.reduce(arrayReducer, []).reduce(objectReducer, {}).unionName, 
        role: jobsByDay.reduce(arrayReducer, []).reduce(objectReducer, {}).role, 
    }))
    .filter(user => !showOvertimes?true:user.hours.map(day => day.ot1 + day.ot2).reduce(numberReducer, 0))
    .map(user => ({...user, hours: user.hours.map(day => ({
        ...day, 
        jobs: showOvertimes && !(day.ot1 + day.ot2)?[]:day.jobs,
        regular: showOvertimes && !(day.ot1 + day.ot2)?0:day.regular,
        travel: showOvertimes && !(day.ot1 + day.ot2)?0:day.travel,
    }))})), 
    [filteredData, showAll, department, usersList, showOvertimes, weekIndexes]);
    //-------------------------------------------------
    useEffect(() => {
        let isMounted = true;
        const week = history.location.pathname.split("/")[2];
        const getData = async () => {
            //-------------------------------------------------
            setShowLoading(true);
            const resWeeks = await myAxios("payroll/readLaborWorkLogsWeek.php");
            if(!isMounted) return;
            setShowLoading(false);
            if(!resWeeks) return;
            //-------------------------------------------------
            const dateArray = [];
            const dateMin = new Date(resWeeks.data.minTime.replace(/-/g, "/"));
            const dataMax = new Date(resWeeks.data.maxTime.replace(/-/g, "/"));
            while(dateMin < dataMax){
                dateArray.push(weeknum(dateMin));
                dateMin.setDate(dateMin.getDate() + 7);
            }
            if(!dateArray.includes(weeknum(dataMax))){
                dateArray.push(weeknum(dataMax));
            }
            setWeeks(dateArray.sort((a, b) => (a < b) ? 1 : -1));
            const currentWeek = weeknum(new MyDate());
            const formData = new MyFormData();
            if(!week){
                formData.append("weekStart", getDatefromWeekNum0(currentWeek, 0).toLocaleDateString("fr-CA", {timeZone: "America/Los_Angeles"}));
                formData.append("weekEnd", getDatefromWeekNum0(currentWeek, 7).toLocaleDateString("fr-CA", {timeZone: "America/Los_Angeles"}));
            }else{
                formData.append("weekStart", getDatefromWeekNum0(week, 0).toLocaleDateString("fr-CA", {timeZone: "America/Los_Angeles"}));
                formData.append("weekEnd", getDatefromWeekNum0(week, 7).toLocaleDateString("fr-CA", {timeZone: "America/Los_Angeles"}));
            }
            //-------------------------------------------------
            setShowLoading(true);
            const res = await myAxios("payroll/readLaborWorkLogs.php", formData);
            if(!isMounted) return;
            setShowLoading(false);
            if(!res) return;
            //-------------------------------------------------
            setUsersList(res.data.userList);
            const currentRawData = res.data.labors;
            if(currentRawData && currentRawData.length){
                const currentData = currentRawData.map(raw => ({...raw, 
                    travelStartTime: raw.travelStartTime?.replace(/-/g, "/"),
                    workStartTime: raw.workStartTime?.replace(/-/g, "/"),
                    workEndTime: raw.workEndTime?.replace(/-/g, "/"),
                    travelEndTime: raw.travelEndTime?.replace(/-/g, "/"),
                    startTime: raw.startTime?.replace(/-/g, "/"),
                    endTime: raw.endTime?.replace(/-/g, "/"),
                    coords: raw.coords?raw.coords.split(","):false,
                    startLocation: raw.startLocation?raw.startLocation:'',
                    yardReason: raw.yardReason?raw.yardReason:'N/A',
                    lunchStart: raw.lunchStart?raw.lunchStart:'',
                    lunchEnd: raw.lunchEnd?raw.lunchEnd:'',
                    noLunchReason: raw.noLunchReason?raw.noLunchReason:'N/A'
                }));
                if(!week){
                    history.push(`/Payroll/${currentWeek}`);
                }
                setRawData(currentData);
            }else{
                setRawData(currentRawData || []);
            }
            //-------------------------------------------------
            // Fetch override hours
            const overrideFormData = new MyFormData();
            overrideFormData.append("week", week || currentWeek);
            const resOverrides = await myAxios("payroll/readHoursOverride.php", overrideFormData);
            if(!isMounted) return;
            if(resOverrides && resOverrides.data && resOverrides.data.data){
                setOverrideHours(resOverrides.data.data);
            }else{
                setOverrideHours([]);
            }
        }
        getData();
        return () => isMounted = false
    }, [history, week, updateDateTime]);
    useEffect(() => {
        document.title = tabTitle;
        return () => {
            document.title = appTitle;
        };
    }, [tabTitle]);
    //-------------------------------------------------
    return (
        <div className = "cssTab">
            <div className = "cssHeader" style = {{background: curUser.userTheme}}>
                <span>
                    <Resize/>
                    Payroll
                    <span data-toggle = "tooltip" title = {"Refreshed on " + updateDateTime} className = "btn btn-primary py-1 ml-4" onClick = {() => setUpdateDateTime(getTimeStamp())}>↻</span>
                </span>
                <div>
                    <input
                        className = "form-control w-auto"
                        type = "text"
                        onChange = {e => {
                            setFilterWords(e.currentTarget.value.toLowerCase());
                        }}
                    />
                    <img
                        alt = ""
                        src = {magnifierImg}
                    />
                </div>
                <span className = "d-flex align-items-center">
                    <label className = "mb-0" htmlFor = "week">Week:</label>
                    <select
                        id = "week"
                        className = "form-control w-auto ml-3"
                        value = {week}
                        onChange = {e => {
                            history.push(`/Payroll/${e.currentTarget.value}`);
                        }}
                    >
                        {weeks.map((wk, key) => <option key = {key}>{wk}</option>)}
                    </select>
                </span>
                <span className = "d-flex align-items-center">
                    <label className = "mb-0" htmlFor = "status">Status:</label>
                    <select
                        id = "status"
                        className = "form-control w-auto ml-2"
                        value = {status}
                        onChange = {e => {
                            setStatus(e.currentTarget.value)
                        }}
                    >
                        <option>All</option>
                        <option value = "Created">Unsubmitted</option>
                        <option>Submitted</option>
                        <option>Approved</option>
                        <option>Billed</option>
                        <option>Rejected</option>
                    </select>
                </span>
                <span className = "d-flex align-items-center">
                    <label className = "mb-0" htmlFor = "showTime">Show Times:</label>
                    <input
                        id = "showTime"
                        type = "checkbox"
                        checked = {showTimes}
                        className = "cssCheckBox ml-2"
                        onChange = {e => {
                            if(e.currentTarget.checked){
                                setShowTimes(true);
                            }else{
                                setShowTimes(false);
                            }
                        }}
                    />
                </span>
                <span className = "d-flex align-items-center">
                    <label className = "mb-0" htmlFor = "showHours">Show Hours:</label>
                    <input
                        id = "showHours"
                        type = "checkbox"
                        checked = {showHours}
                        className = "cssCheckBox ml-2"
                        onChange = {e => {
                            if(e.currentTarget.checked){
                                setShowHours(true);
                            }else{
                                setShowHours(false);
                            }
                        }}
                    />
                </span>
                <span className = "d-flex align-items-center">
                    <label className = "mb-0" htmlFor = "department">Department:</label>
                    <select
                        id = "department"
                        className = "form-control w-auto ml-3"
                        value = {department}
                        onChange = {e => {
                            setDepartment(e.currentTarget.value);
                        }}
                    >
                        {departments.map((d, key) => <option key = {key}>{d}</option>)}
                        <option>Outside Service</option>
                    </select>
                </span>
                
                <span className = "d-flex align-items-center">
                    <label className = "mb-0" htmlFor = "showAll">Show All Technicians:</label>
                    <input
                        id = "showAll" 
                        type = "checkbox"
                        className = "cssCheckBox ml-2"
                        onChange = {e => {
                            if(e.currentTarget.checked){
                                setShowAll(true);
                            }else{
                                setShowAll(false);
                            }
                        }}
                    />
                </span>
                <span className = "d-flex align-items-center">
                    <label className = "mb-0" htmlFor = "laborCategory">Labor Category:</label>
                    <select
                        id = "laborCategory"
                        className = "form-control w-auto ml-2"
                        value = {laborCategory}
                        onChange = {e => {
                            setLaborCategory(e.currentTarget.value);
                        }}
                    >
                        <option>All</option>
                        <optgroup label = "Field Work">
                            {laborCategorys.map((d, key) => <option key = {key}>{d}</option>)}
                        </optgroup>
                        <optgroup label = "Shop Works">
                            {laborShopsCategorys.map((d, key) => <option key = {key}>{d}</option>)}
                        </optgroup>
                    </select>
                </span>
                <span className = "d-flex align-items-center">
                    <label className = "mb-0" htmlFor = "showOvertimes">Only Overtimes:</label>
                    <input
                        id = "showOvertimes"
                        type = "checkbox"
                        checked = {showOvertimes}
                        className = "cssCheckBox ml-2"
                        onChange = {e => {
                            if(e.currentTarget.checked){
                                setShowOvertimes(true);
                            }else{
                                setShowOvertimes(false);
                            }
                        }}
                    />
                </span>
                <Export
                    userEveryDayCalculatedData = {userEveryDayCalculatedData}
                    filteredData = {filteredData}
                />
                <CSVExport week={week} department={department} />
            </div>
            {showLoading?<div className = "cssContent pb10"><div className = "cssLoading">Loading...</div></div>:
            !filteredData.length?<div className = "cssContent pb10"><div className = "cssLoading">Empty</div></div>:
            <div>
                <div className = "text-center font-weight-bold my-3">
                    <span className = "font-weight-bold mr-4">Status Color Code</span>
                        {["All", "Created"].includes(status)?<span style = {{color: "red", padding: 10, border: "1px solid black", borderRight: conditionalBorder}}>Unsubmitted ({filteredData.map(f => ({...f, workLogStatus:f.projectHashKey === restDayProjectHashKey?"Approved":f.workLogStatus})).filter(v => v.workLogStatus === "Created").length})</span>:<></>}
                        {["All", "Submitted"].includes(status)?<span style = {{color: "purple", padding: 10, border: "1px solid black", borderLeft: conditionalBorder, borderRight: conditionalBorder}}>Submitted ({filteredData.filter(v=> v.workLogStatus === "Submitted").length})</span>:<></>}
                        {["All", "Approved"].includes(status)?<span style = {{color: "green", padding: 10, border: "1px solid black", borderLeft: conditionalBorder, borderRight: conditionalBorder}}>Approved ({filteredData.map(f => ({...f, workLogStatus:f.projectHashKey === restDayProjectHashKey?"Approved":f.workLogStatus})).filter(v=> v.workLogStatus === "Approved").length})</span>:<></>}
                        {["All", "Billed"].includes(status)?<span style = {{color: "pink", padding: 10, border: "1px solid black", borderLeft: conditionalBorder, borderRight: conditionalBorder}}>Billed ({filteredData.filter(v=> v.billed === "Yes").length})</span>:<></>}
                        {["All", "Rejected"].includes(status)?<span style = {{color: "gray", padding: 10, border: "1px solid black", borderLeft: conditionalBorder}}>Rejected ({filteredData.filter(v=> v.workLogStatus === "Rejected").length})</span>:<></>}
                </div>
                <div className = "overflow-visible">
                    <table className = "table">
                        <thead>
                            <tr className = "stickyHeader">
                                <th>Name ({userEveryDayCalculatedData.length})</th>
                                <th>Monday {week?`(${getDatefromWeekNum(week, 0)})`:""}</th>                    
                                <th>Tuesday {week?`(${getDatefromWeekNum(week, 1)})`:""}</th>
                                <th>Wednesday {week?`(${getDatefromWeekNum(week, 2)})`:""}</th>
                                <th>Thursday {week?`(${getDatefromWeekNum(week, 3)})`:""}</th>
                                <th>Friday {week?`(${getDatefromWeekNum(week, 4)})`:""}</th>
                                <th>Saturday {week?`(${getDatefromWeekNum(week, 5)})`:""}</th>
                                <th>Sunday {week?`(${getDatefromWeekNum(week, 6)})`:""}</th>
                            </tr>
                            </thead>
                            <tbody> 
                            {userEveryDayCalculatedData.map((v, key) =>
                                <tr key = {key}>
                                    <td>
                                        <div className = "font-weight-bold">
                                            {showAll?
                                                <UserInfo name = {v.userName} email = {v.email}/>:
                                                <UserInfo name = {v.userName} email = {v.labor}/>    
                                            }
                                        </div>
                                        {showHours?<>
                                        <div>
                                            <span className = "mr-2"><strong>Travel</strong>: {userEveryDayCalculatedData[key].hours.map(xx => xx.travel).reduce(numberReducer, 0)}</span>
                                        </div>
                                        <div>
                                            <span className = "mr-2"><strong>Reg</strong>: {userEveryDayCalculatedData[key].hours.map(xx => xx.regular).reduce(numberReducer, 0)}</span>
                                        </div>
                                        <div>
                                            <span className = "mr-2"><strong>OT1</strong>: {userEveryDayCalculatedData[key].hours.map(xx => xx.ot1).reduce(numberReducer, 0)}</span>
                                        </div>
                                        <div>
                                            <span className = "mr-2"><strong>OT2</strong>: {userEveryDayCalculatedData[key].hours.map(xx => xx.ot2).reduce(numberReducer, 0)}</span>
                                        </div>
                                        </>:<></>}
                                    </td>
                                    {weekIndexes.map(num => <td key = {num}>
                                        {v.hours[num].jobs
                                        .map((vv, vvi) => 
                                        <li key = {vvi}>
                                            <Link to = {`/Projects/${vv.projectHashKey}/WorkInstructions/${vv.workInstructionHashKey}/WorkLogs/${vv.workLogHashKey}`}>
                                                <span
                                                    className = "font-weight-bold"
                                                    style = {{
                                                        color:
                                                        vv.projectHashKey === restDayProjectHashKey?"green":
                                                        simpleStatusColorCode[vv.workLogStatus]
                                                    }}
                                                >
                                                    {vv.projectNumber} - {vv.organizationName} - {vv.clientProjectNumber}
                                                </span>
                                                <div className = "font-weight-bold text-dark">
                                                    {
                                                        vv.startTime.substring(0, 10) === vv.endTime.substring(0, 10)?
                                                            vv.startTime.substring(11, 16) === "00:00" && vv.endTime.substring(11, 16) === "00:00"?
                                                            ``
                                                            :
                                                            `${vv.startTime.substring(11, 16)} ~ ${vv.endTime.substring(11, 16)}`
                                                        :
                                                            vv.startTime.substring(11, 16) === "00:00" && vv.endTime.substring(11, 16) === "00:00"?
                                                            `Overnight`
                                                            :
                                                            `${vv.startTime.substring(11, 16)} ~ ${vv.endTime.substring(0, 16)}`
                                                    }
                                                    {vv.billed === "Yes"?<span style = {{color: "pink"}}>&nbsp;Billed</span>:<></>}
                                                </div>
                                            </Link>
                                            <span className = "text-info">{vv.laborCategory}</span>
                                            {vv.truckNumber?<span className = "text-secondary ml-2">truck {vv.truckNumber}</span>:<></>}
                                            {vv.coords?
                                            <a className = "ml-2" href = {`https://www.google.com/maps/search/${vv.coords.slice(0, 2).join(",")}`} target = "_blank" rel = "noreferrer">
                                                Coordinates: {vv.coords.slice(0, 2).join(",")} Accuracy: {vv.coords[2]} meters
                                            </a>
                                            :<></>}
                                            {showTimes && vv.projectHashKey !== restDayProjectHashKey?
                                            <ul>
                                                <li>
                                                    <span className = "font-weight-bold mr-2">Pre-Driver:</span>
                                                    {vv.preDriver}
                                                </li>
                                                <li>
                                                    <span className = "font-weight-bold mr-2">Travel Start:</span>
                                                    {vv.travelStartTime !== defaultEmptyDateTime.replace(/-/,"/")?(
                                                        (new Date(vv.travelStartTime.substring(0, 10).replace(/-/g, "/"))).getDay() === num?
                                                        vv.travelStartTime.substring(10, 16):
                                                        vv.travelStartTime.substring(0, 16)
                                                    ):""}
                                                </li>
                                                {vv.laborCategory === "Travel"?<></>:<>
                                                <li>
                                                <span className = "font-weight-bold mr-2">Work Start:</span>
                                                {vv.workStartTime !== defaultEmptyDateTime.replace(/-/,"/")?(
                                                        (new Date(vv.workStartTime.substring(0, 10).replace(/-/g, "/"))).getDay() === num?
                                                        vv.workStartTime.substring(10, 16):
                                                        vv.workStartTime.substring(0, 16)
                                                    ):""}
                                                </li>
                                                <li>
                                                    <span className = "font-weight-bold mr-2">Had Lunch:</span>
                                                    {vv.hadLunch}
                                                </li>
                                                <li>
                                                    <span className = "font-weight-bold mr-2">Start Location:</span>
                                                    {vv.startLocation}
                                                </li>
                                                <li>
                                                    <span className = "font-weight-bold mr-2">Yard Reason:</span>
                                                    {vv.yardReason}
                                                </li>
                                                {vv.hadLunch === "Yes" && (
                                                    <>
                                                        <li>
                                                            <span className = "font-weight-bold mr-2">Lunch Start:</span>
                                                            {vv.lunchStart}
                                                        </li>
                                                        <li>
                                                            <span className = "font-weight-bold mr-2">Lunch End:</span>
                                                            {vv.lunchEnd}
                                                        </li>
                                                    </>
                                                )}
                                                {vv.hadLunch === "No" && (
                                                    <li>
                                                        <span className = "font-weight-bold mr-2">No Lunch Reason:</span>
                                                        {vv.noLunchReason}
                                                    </li>
                                                )}
                                                <li> 
                                                <span className = "font-weight-bold mr-2">Work End:</span>
                                                {vv.workEndTime !== defaultEmptyDateTime.replace(/-/g, "/")?(
                                                        (new Date(vv.workEndTime.substring(0, 10).replace(/-/g, "/"))).getDay() === num?
                                                        vv.workEndTime.substring(10, 16):
                                                        vv.workEndTime.substring(0, 16)
                                                    ):""}
                                                </li>
                                                </>}
                                                <li>
                                                    <span className = "font-weight-bold mr-2">Travel End:</span>
                                                    {vv.travelEndTime !== defaultEmptyDateTime.replace(/-/g, "/")?(
                                                        (new Date(vv.travelEndTime.substring(0, 10).replace(/-/g, "/"))).getDay() === num?
                                                        vv.travelEndTime.substring(10, 16):
                                                        vv.travelEndTime.substring(0, 16)
                                                    ):""}
                                                </li>
                                                <li>
                                                    <span className = "font-weight-bold mr-2">Post-Driver:</span>
                                                    {vv.postDriver}
                                                </li>
                                            </ul>:<></>}
                                        </li>)}
                                        {showHours && v.projectHashKey !== restDayProjectHashKey?<>
                                        {v.hours[num].jobs.length?
                                            <>
                                            {allCreated(v.hours[num].jobs)?<></>:<>
                                            {(() => {
                                                const override = getOverrideForEmployeeDay(v.labor, num);
                                                return Object.entries(userEveryDayCalculatedData[key].hours[num]).filter(([key, value]) => key !== "jobs").map(([key, value]) =>
                                                    <li key = {key}>
                                                        <span className = "font-weight-bold mr-2">{key}:</span>
                                                        {override && override[key] !== undefined ? (
                                                            <>
                                                                <span style = {{textDecoration: "line-through", color: "#999"}}>{value}</span>
                                                                <span className = "ml-2 font-weight-bold" style = {{color: "#007bff"}}>{override[key]}</span>
                                                            </>
                                                        ) : value}
                                                    </li>
                                                );
                                            })()}
                                            {curUser.payroll === 'edit' && <div className = "mt-2">
                                                <button 
                                                    className = "btn btn-sm btn-primary"
                                                    onClick = {() => handleEditHours(
                                                        v, 
                                                        num, 
                                                        userEveryDayCalculatedData[key].hours[num]
                                                    )}
                                                >
                                                    Edit Hours
                                                </button>
                                            </div>}
                                            </>}
                                            </>:<></>
                                        }</>:<></>}
                                    </td>)}
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>}
            {showEditModal && (
                <div className = "modal show d-block" style = {{backgroundColor: "rgba(0,0,0,0.5)"}}>
                    <div className = "modal-dialog">
                        <div className = "modal-content">
                            <div className = "modal-header">
                                <h5 className = "modal-title">Edit Hours - {editHoursData.userName}</h5>
                                <button 
                                    type = "button" 
                                    className = "close" 
                                    onClick = {() => setShowEditModal(false)}
                                >
                                    <span>&times;</span>
                                </button>
                            </div>
                            <div className = "modal-body">
                                <div className = "form-group">
                                    <label>Regular Hours</label>
                                    <input 
                                        type = "number" 
                                        className = "form-control"
                                        step = "0.01"
                                        value = {editHoursData.regular}
                                        onChange = {e => setEditHoursData({...editHoursData, regular: parseFloat(e.target.value) || 0})}
                                    />
                                </div>
                                <div className = "form-group">
                                    <label>OT1 Hours</label>
                                    <input 
                                        type = "number" 
                                        className = "form-control"
                                        step = "0.01"
                                        value = {editHoursData.ot1}
                                        onChange = {e => setEditHoursData({...editHoursData, ot1: parseFloat(e.target.value) || 0})}
                                    />
                                </div>
                                <div className = "form-group">
                                    <label>OT2 Hours</label>
                                    <input 
                                        type = "number" 
                                        className = "form-control"
                                        step = "0.01"
                                        value = {editHoursData.ot2}
                                        onChange = {e => setEditHoursData({...editHoursData, ot2: parseFloat(e.target.value) || 0})}
                                    />
                                </div>
                                <div className = "form-group">
                                    <label>Travel Hours</label>
                                    <input 
                                        type = "number" 
                                        className = "form-control"
                                        step = "0.01"
                                        value = {editHoursData.travel}
                                        onChange = {e => setEditHoursData({...editHoursData, travel: parseFloat(e.target.value) || 0})}
                                    />
                                </div>
                            </div>
                            <div className = "modal-footer">
                                <button 
                                    type = "button" 
                                    className = "btn btn-secondary" 
                                    onClick = {() => setShowEditModal(false)}
                                >
                                    Cancel
                                </button>
                                <button 
                                    type = "button" 
                                    className = "btn btn-primary" 
                                    onClick = {handleSaveEditedHours}
                                >
                                    Save Changes
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}